<style>

</style>

<template>
  <div id="app-layout">
    <transition name="faded-full"
                enter-active-class="fadeIn"
                leave-active-class="fadeOut"
                mode="out-in">
                <!-- v-if="!loaded" -->
                <div class="loaderWrapper" v-if="$global.loading">
                  <div class="logos">
                      <img class="logo logo-1" src="../../assets/logo.png" alt="Young Enterprise" width="250">
                      <img class="logo logo-2" src="../../assets/mmw.png" alt="My Money Week" width="140">
                  </div>
                  <div class="loaderMMW" >
                    <svg id="clockLoader" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
                      <circle fill="none" stroke="#fff" stroke-width="4" stroke-miterlimit="10" cx="50" cy="50" r="48"/>
                      <line fill="none" stroke-linecap="round" stroke="#b8bf0d" stroke-width="4" stroke-miterlimit="10" x1="50" y1="50" x2="85" y2="50.5">
                        <animateTransform 
                            attributeName="transform" 
                            dur="1.5s"
                            type="rotate"
                            from="0 50 50"
                            to="360 50 50"
                            repeatCount="indefinite" />
                      </line>
                      <line fill="none" stroke-linecap="round" stroke="#b8bf0d" stroke-width="4" stroke-miterlimit="10" x1="50" y1="50" x2="49.5" y2="74">
                        <animateTransform 
                            attributeName="transform" 
                            dur="12s"
                            type="rotate"
                            from="0 50 50"
                            to="360 50 50"
                            repeatCount="indefinite" />
                      </line>
                    </svg>
                    <!-- <div class="loaderMMW_text">Loading...</div> -->
                  </div>
                </div>
    </transition>
    <app-header :VideoData="VideoData" :headerSession="headerSession" :isLoading="$global.loading"></app-header>
    <!-- Transition is core vue that adds the animation class. Animation CSS is included using https://www.npmjs.com/package/vue2-animate -->
    <div class="page-wrap" :class = "{'page-full-height' : isFullscreen == true}">
      <transition name="faded-full"
                  enter-active-class="fadeIn"
                  leave-active-class="fadeOut"
                  mode="out-in">
        <router-view v-if="loaded" :key="this.$route.fullPath" :VideoData="VideoData" class="inner-wrap" @headerChange="headerChange" v-bind:class="{ innerWrapLogged: headerSession }"></router-view>
      </transition>
      <modal name="reset-form" id="resetModal" 
          reset=true
          transition="fade"
          overlayTransition="fade"
          height="auto"
          scrollable=true
          width="400px"
          pivotY=0.5>
          <form @submit.prevent="resetPassword(form)" key="4" id="resetForm" autocomplete="new-password">
              <div class="row inputs">
                  <h3 class="formCategory"><span v-if="headerSession">{{appTextLanguage.introform.change[language]}}</span><span v-else>{{appTextLanguage.introform.reset[language]}}</span> {{appTextLanguage.introform.password[language]}}</h3>
                  <div class="col-12">
                      <span class="help is-danger">{{resetError}}</span>
                  </div>
                  <input type="hidden" name="key" v-validate.disable="'required'" v-model="form.key">
                  <div class="col-xs-2">
                      <label for="resetemail" class="form-label">{{appTextLanguage.account.emailAddress[language]}}</label>
                      <input v-validate.disable="'required|email'" class="form-input"
                          :class="{'input': true, 'is-danger': errors.has('resetemail') }" v-model.trim="form.resetemail"
                          type="text" name="resetemail" id="resetemail" autocomplete="new-password"/>
                      <span class="help is-danger">{{ errors.first('resetemail') }}</span>
                  </div>
                  <div class="col-xs-2">
                      <label for="resetpassword" class="form-label">{{appTextLanguage.account.newPassword[language]}}</label>
                      <input v-validate.disable="'required|min:6|upCase'" class="form-input"
                          :class="{'input': true, 'is-danger': errors.has('resetpassword') }" v-model.trim="form.resetpassword"
                          :type="passwordShow" name="resetpassword" id="resetpassword" autocomplete="new-password"/>
                          <div class="passwordShow" @click="showPassword" :class="{'showing': passwordShow === 'text'}"></div>
                      <span class="help is-danger">{{ errors.first('resetpassword') }}</span>
                  </div>
              </div>
              <div class="row submit">
                  <div class="col-xs-12 btn-holder">
                      <div class="btn-wrap btn-wrap-start">
                          <input type="submit" :value="[headerSession ? this.appTextLanguage.account.changePassword[language] : this.appTextLanguage.account.resetPassword[language]] " class="btn btn-primary"/>
                      </div>
                  </div>
              </div>
          </form>
      </modal>
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
    import { mapMutations, mapActions, mapState } from 'vuex';
    import Data from '../../plugins/data.js';
    import AppHeader from '../global/AppHeader.vue';
    import AppFooter from '../global/AppFooter.vue';

    export default {
      components:{
          AppFooter,
          AppHeader,
      },
      data: function () {
          return {
              language: null,
              appTextLanguage: null,
              VideoData: [],
              loaded : false,
              headerSession: false,
              hasReset: false,
              form: {
                resetemail: null,
                resetpassword: null,
                key: null
              },
              resetError: null,
              passwordShow: 'password'
          }
      },
      created(){

         

          let vm = this;
          const resetKey = this.$route.query.key;
          if(resetKey) {
            this.form.key = resetKey;
            let query = Object.assign({}, this.$route.query);
            delete query.key;
            this.$router.replace({ query });
            setTimeout(() => {
              this.$modal.show('reset-form');
            }, 1000);
          }

          this.appTextStatic = this.$store.getters.getAppTextStatic;
          const stateApp = this.$store.state;
          const language = this.$store.getters.getLanguage;
          this.setLanguage(language);
          
          const getAppTextByLanguage = this.getAppTextByLanguage;

          this.appTextLanguage = this.$store.getters.getAppTextLanguage;
          this.language = this.$store.getters.getLanguage;
          
          var token = this.$store.getters.getBearerToken;

          // Grab status before everything
          this.$http.get(process.env.WP_ENDPOINT + 'mmw/v1/mmw-status', {timeout: 60000, chained: true}).then(function (response) {

              console.log('MMW Status: ' + response.data.data.state);
              this.$store.commit('setMMWStatus', response.data.data);
              console.log('Check me'); console.log(token);
              if( token == null){
                // not logged in
                this.$store.commit('setLostAccess');
                setTimeout(() => {
                    this.$global.loading = false;
                    vm.loaded = true;
                }, 300);
                
              } else {
                this.$http.post(process.env.WP_ENDPOINT + 'jwt-auth/v1/token/validate', {chained: true}, {
                    headers: {
                        'Authorization': 'Bearer ' + token
                    },
                    timeout: 60000
                }).then(function (response) {
                    // console.log(response.data);
                    if (response.data != null && response.data != '' && response.data.data.status == "200") {
                        // Valid, keep logged in.
                        // console.log('Still logged in');
                        vm.headerSession = true;
                        this.loadAllData(token);
                        this.$store.commit('setHasAccess');
                        return true;
                    } 
                    else if (response.data != null && response.data != '' && response.data.data.status == "403") {
                        // Remve and require reaccess
                        this.$store.commit('setLostAccess');
                        setTimeout(() => {
                            this.$router.go();
                            // vm.loaded = true;
                        }, 300);
                    }
                }, function (response) {
                    // Error
                    console.log(response);
                    this.$store.dispatch('genericError', 'Apologies, something appears to have gone wrong and you have been logged out.', 10000);
                    this.$store.commit('setLostAccess');
                    setTimeout(() => {
                      this.$router.go();
                        // vm.loaded = true;
                    }, 300);
                });
              }
          }, function (response) {
              // Error - Site shouldn't function if we can't do this
              console.log(response);
              this.$store.dispatch('genericError', this.appTextLanguage.account.error[this.language]);
          });

          const dictionary = {
              en: {
                  messages:{
                      required: field => this.appTextLanguage.account.the[this.language] + ' ' + field.replace('forgotten_email', 'email').replace(/_/g, ' ').replace('login', '').replace('resetemail', 'email').replace('resetpassword', 'new password') +  ' ' + this.appTextLanguage.account.fieldRequiredRaw[this.language],
                      min: () => this.appTextLanguage.account.passwordRequirement[this.language],
                      email: () => this.appTextLanguage.account.emailFormat[this.language]
                  }
              }
          };

          this.$validator.localize(dictionary);
      },
      methods: {
        ...mapMutations({
        setLanguage: 'setLanguage'
        }),
        ...mapActions({
          getAppText: 'getAppText'
        }),
        setNewLanguage(language="")
        {
          this.setLanguage(language);
          this.getAppTextByLanguage(language);
        },
        
        getAppTextByLanguage(language="")
        {
          if(language == "cy")
          {
            this.$store.state.appText = this.$store.state.appTextCy;
          }
          else
          {
            this.$store.state.appText = this.$store.state.appTextEn;
          }
        },
        showPassword() {
            this.passwordShow = this.passwordShow === 'password' ? 'text' : 'password';
        },
        loadAllData(token){
          // Load all data from API
          this.$http.get(process.env.WP_ENDPOINT + 'mmw/v1/mmw-loaddata', {
                headers: {
                    'Authorization': 'Bearer ' + token
                },
                timeout: 60000
              }).then(function (response) {
              // console.log('loadAllData');
              // console.log(response.data);
              if(response.data.code == 200) {
                // Store years
                this.$store.commit('setYears', response.data.data.years);
                this.$store.commit('setResources', response.data.data.resources);
                this.$store.commit('setResourcesWelsh', response.data.data.resourcesWelsh);

                // Load local videos
                this.getVideos(response.data.data.years);
              }
          }, function (response) {
              // Error - Site shouldn't function if we can't do this
              console.log(response);
              this.$store.dispatch('genericError', this.appTextLanguage.account.error[this.language]);
          });    
        },
        getVideos(years){
          var videoData = {};
          var itemsProcessed = 0;
          var vm = this;
          years.forEach((value) => {
              Data.videosForLive(value, 'primary').then(response => {
                var primaryVideos = response;

                Data.videosForLive(value, 'secondary').then(response => {
                  videoData[value] = {
                    primary: primaryVideos,
                    secondary: response
                  }
                  itemsProcessed++;
                  // console.log(videoData);
                  if(itemsProcessed === years.length) {
                    console.log('All Done, commit');
                    console.log(videoData);
                    this.VideoData = videoData;
                    this.$store.commit('setVideoData', videoData);
                    vm.loaded = true;
                  }
                });
              });
          });


        },
        headerChange(ev){
          if (ev == true) {
              this.headerSession = true;
              this.loaded = false;
              this.loadAllData(this.$store.getters.getBearerToken);
          } else {
              this.headerSession = true;
          }
        },
        resetPassword(form) {
          // console.log(form);
          this.$validator.extend('upCase', {
              getMessage: () => this.appTextLanguage.account.passwordRequiredUpper[this.language],
              validate: value => value.match(/[A-Z]/g) !== null
          });
          this.$validator.validateAll().then((result) => {
              if (result) {
                // Send to WP
                let data = {};
                data.user_login = form.resetemail;
                data.newpassword = form.resetpassword;
                data.key = form.key;

                let vm = this;
                this.$http.post(process.env.WP_ENDPOINT + 'mmw/v1/resetpassword', data, {timeout: 60000}).then(function (response) {
                    // console.log(response.data);
                    if(response.data.code == 200) {
                        this.$modal.hide('reset-form');
                        this.$toasted.show(this.appTextLanguage.introform.passwordSuccess[this.language], {
                            duration: 6000,
                            position: 'top-center',
                            type: "success",
                            action: {
                                text: this.appTextLanguage.introform.close[this.language],
                                onClick : (e, toastObject) => {
                                    toastObject.goAway(0);
                                }
                            }
                        });
                    }
                },function (response) {
                    // Error
                    console.log(response.data);
                    if(response.data.message == 'Invalid key') {
                      this.resetError = 'Reset key is invalid or has expired, please requesting a new reset and try again.';
                    } else {
                      this.$store.dispatch('genericError', this.appTextLanguage.account.error[this.language]);
                    }
                    
                });
              }
          });

        }
      },
      computed: mapState([
       // map this.school to store.state.school etc.
       'isFullscreen'
      ]),
      watch: {
            '$store.state.language': function () {
                this.language = this.$store.getters.getLanguage;
            }
      }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/layout/Layout.vue